export default function () {
  return {
    restrict: "A",
    require: "ngModel",
    link: function (scope, element, attrs, ngModel) {

      const read = () => { 
        ngModel.$setViewValue(element.html()); 
      }

      ngModel.$render = () => { 
        element.html(ngModel.$viewValue || ""); 
      };

      element.bind("keyup change blur", () => { 
        scope.$apply(read); 
      });
    }
  }
};